/**
 * Clickstream Component
 */

import { type App } from '~/app';

import ClickStream from './ClickStream.vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Clickstream Component');
    app.vueApp.component('click-stream', ClickStream);
};

